import type { AddressInput } from '@/schemas/address'
import { capitalize } from 'vue'

type NullishProperties<T> = {
  [K in keyof T]?: T[K] | null
}

export const addressToString = (address?: NullishProperties<AddressInput>) => {
  if (!address) return ''

  const suburb = address.suburb
    ?.split(' ')
    .filter(Boolean)
    .map((x) => capitalize(x))
    .join(' ')

  const area = [suburb, address.state?.trim(), address.postcode?.trim()].filter(Boolean).join(' ')

  return [address.address2?.trim(), address.address1?.trim(), area].filter(Boolean).join(', ').trim()
}

export const addressWithCompanyName = (address?: NullishProperties<AddressInput>) => {
  if (!address?.companyName) {
    return addressToString(address)
  }

  return `${address.companyName.trim()}, ${addressToString(address)}`
}
